(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["module", "exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(module, exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports);
    global.enUS = mod.exports;
  }
})(this, function (module, exports) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = {
    "rich": {
      "validator": {
        "type": {
          "array": "Data type should be an array",
          "url": "Please enter a valid URL",
          "date": "Please enter a valid date",
          "email": "Please enter a valid email",
          "string": "Please enter characters",
          "tel": "Please enter a valid mobile number",
          "number": "Please enter numbers"
        },
        "max": {
          "tel": "Cannot exceed {{config}} characters",
          "number": "Cannot be more than {{config}}",
          "email": "Cannot exceed {{config}} characters",
          "url": "Cannot exceed {{config}} characters",
          "date": "Please select a date before {{config | toLocaleDateString(\"yyyy-MM-dd\")}}",
          "array": "Select up to {{config}} items",
          "string": "Cannot exceed {{config}} characters"
        },
        "min": {
          "string": "Must enter at least {{config}} characters",
          "array": "Please select a minimum of {{config}} items",
          "email": "Must enter at least {{config}} characters",
          "tel": "Must enter at least {{config}} characters",
          "number": "Cannot be less than {{config}}",
          "date": "Please select a date after {{config | toLocaleDateString(\"yyyy-MM-dd\")}}",
          "url": "Must enter at least {{config}} characters"
        },
        "len": {
          "string": "Please enter {{config}} characters",
          "number": "Length should be equal to {{config}}",
          "array": "Please select {{config}} items",
          "tel": "Please enter {{config}} characters",
          "date": "Please select a date before {{config | toLocaleDateString(\"yyyy-MM-dd\")}}",
          "email": "Please enter {{config}} characters",
          "url": "Please enter {{config}} characters"
        },
        "notWhitespace": "Invalid blank content",
        "custom": "Verification failed",
        "pattern": "Format error",
        "required": "This is required"
      },
      "timePicker": {
        "minutes": "",
        "hours": "",
        "today": "Today",
        "formatDate": "MM/DD",
        "selectTime": "Select Time",
        "now": "Now"
      },
      "textArea": {
        "placeholder": "Please specify..."
      },
      "resultPage": {
        "networkSubtext": "Click to Reload",
        "emptyText": "No data available",
        "networkText": "Network error",
        "lostText": "The page you are looking for could not be found"
      },
      "common": {
        "selectText": "Please select",
        "ok": "OK",
        "cancel": "Cancel",
        "confirm": "OK"
      },
      "segmentPicker": {
        "next": "Next",
        "prev": "Back"
      }
    }
  };
  module.exports = exports["default"];
});